import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo } from "react";
import { MessageBanner } from "../../MessageBanner";
const ErrorBanner = ({ error, setError, isEditable }) => {
    if (!isEditable)
        return null;
    return _jsx(MessageBanner, { onClose: () => setError(""), message: error });
};
export default memo(ErrorBanner);
